export async function fetchLocalFile(url: string, fileName: string): Promise<File | null> {
  if (!url) return null;

  try {
    const response = await fetch(url, { credentials: 'include' });
    const blob = await response.blob();
    return new File([blob], fileName);
  } catch (err) {
    console.error(err);
    return null;
  }
}